import React from "react";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import GridTable from "../../table/gridTable";
import Loader from "../../SharedLayouts/Loader";
import { getCurrencySymbol } from "../../../Helper/getCurrencySymbol";

const statusStyle = (status) => {
  const value = (status || "").toLowerCase();
  if (value === "delivered" || value === "success") {
    return { color: "#128591", backgroundColor: "#E4F9FC" };
  }
  if (value === "failed" || value === "error") {
    return { color: "#C11574", backgroundColor: "#FCCEEE" };
  }
  return { color: "#175CD3", backgroundColor: "#B2DDFF" };
};

const formatAmount = (currency, value) =>
  `${getCurrencySymbol(currency)} ${
    value || value === 0 || value === "0"
      ? Number(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "-"
  }`;

const CoopTransactionsTable = () => {
  const transactions =
    useSelector((state) => state?.coopTransactions?.transactions) || [];
  const loading = useSelector((state) => state?.coopTransactions?.pending);

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "account_number",
      headerName: "Account Number",
      width: 150,
      renderCell: (params) => params.row?.account_number || "-",
    },
    {
      field: "source_account_name",
      headerName: "Source Name",
      width: 200,
      renderCell: (params) => params.row?.source_account_name || "-",
    },
    {
      field: "source_bank_name",
      headerName: "Source Bank",
      width: 150,
      renderCell: (params) => params.row?.source_bank_name || "-",
    },
    {
      field: "transaction_amount",
      headerName: "Amount",
      width: 140,
      renderCell: (params) =>
        formatAmount(params.row?.currency, params.row?.transaction_amount),
    },
    {
      field: "settled_amount",
      headerName: "Settled Amount",
      width: 140,
      renderCell: (params) =>
        formatAmount(params.row?.currency, params.row?.settled_amount),
    },
    {
      field: "fee_amount",
      headerName: "Fee",
      width: 110,
      renderCell: (params) =>
        formatAmount(params.row?.currency, params.row?.fee_amount),
    },
    {
      field: "vat_amount",
      headerName: "VAT",
      width: 110,
      renderCell: (params) =>
        formatAmount(params.row?.currency, params.row?.vat_amount),
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 10px",
            height: "22px",
            borderRadius: "10px",
            textTransform: "capitalize",
            ...statusStyle(params.row?.status),
          }}
        >
          {params.row?.status || "-"}
        </div>
      ),
    },
    {
      field: "session_id",
      headerName: "Session ID",
      width: 240,
      renderCell: (params) => params.row?.session_id || "-",
    },
    {
      field: "settlement_id",
      headerName: "Settlement ID",
      width: 200,
      renderCell: (params) => params.row?.settlement_id || "-",
    },
    {
      field: "tran_date_time",
      headerName: "Transaction Date",
      width: 190,
      renderCell: (params) =>
        params.row?.tran_date_time
          ? new Date(params.row.tran_date_time).toLocaleString()
          : "-",
    },
    {
      field: "tran_remarks",
      headerName: "Remarks",
      width: 400,
      renderCell: (params) => params.row?.tran_remarks || "-",
    },
  ];

  if (loading && transactions?.length < 1) {
    return <Loader />;
  }

  return (
    <div className="mt-10 mb-8">
      <div className="bg-white">
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <GridTable
            rows={transactions}
            columns={columns}
            type={"coop-transactions"}
            searchPlaceholder={"Search Coop Transactions"}
            noReport
          />
        </Box>
      </div>
    </div>
  );
};

export default CoopTransactionsTable;
